import Delete from "../../../assets/icons/trash.svg";
import ModalContainer from "../../modalContainer";
import {useState} from "react";
import DeleteAttendanceModal from "../../deleteAttendanceModal";

function UserAssitence({user, i, deleteRecord}) {
    const [openModalAdd, setOpenModalAdd] = useState(false);

    async function openModal() {
        setOpenModalAdd(true)
    }

    return (
        <>
            {openModalAdd && (
                <ModalContainer>
                    <DeleteAttendanceModal
                        attendance={user}
                        setOpenModalAdd={setOpenModalAdd}
                        deleteRecord={deleteRecord}
                    />
                </ModalContainer>
            )}
            <div className='info-container'>
                <p
                    className={`user-position ${
                        user?.attended ? 'user-position'
                            : 'user-position---false'
                    }`}>
                    {i + 1}
                </p>
                <p
                    className={`user-name ${
                        user?.attended ? 'user-name' : 'user-name---false'
                    }`}>
                    {user?.beneficiary?.full_name}
                </p>
                <p
                    className={`assistence-active ${
                        user?.attended ? 'assistence-active'
                            : 'assistence-active---false'
                    }`}>
                    {user?.attended ? 'Asistió' : 'No asistió'}
                </p>
                <p
                    className={`motive ${
                        user?.attended ? 'motive' : 'motive---false'
                    }`}>
                    {user?.argument}
                </p>
                <p
                    className={`observations ${
                        user?.attended ? 'observations' : 'observations---false'
                    }`}>
                    {user?.notes}
                </p>
                <div className='actions'>
                    <button
                        onClick={openModal}
                        className='button-delete' title='Eliminar'>
                        <img src={Delete} alt=''/>
                    </button>
                </div>
            </div>
        </>
    );
}

export default UserAssitence;
